const Logger = require("../Logger");
const ConfigurationFactory = require("../ConfigurationFactory");
const GCSControllerCDN = require("./GCSControllerCDN");

let legacyUrl;

const service = {};

const getCachedResult = () => {
  try {
    return JSON.parse(localStorage.getItem("gcsResult"));
  } catch (e) {
    Logger.logDebug("No local storage", e);
    return undefined;
  }
};

const getCachedGeneration = () => {
  try {
    const generation = localStorage.getItem("gcsGeneration");
    return generation && generation !== "null" ? generation : undefined;
  } catch (e) {
    Logger.logDebug("No local storage", e);
    return undefined;
  }
};

const setCachedResult = (result, generation) => {
  try {
    localStorage.setItem("gcsResult", JSON.stringify(result));
    if (generation !== undefined && generation !== null) {
      localStorage.setItem("gcsGeneration", generation);
    }
  } catch (e) {
    Logger.logExternalMessage("GCS data cache set fail", e.message);
    Logger.viewerError("E999999999", "GCS data cache set fail", e.message);
  }
};

service.init = () => {
  legacyUrl = undefined;

  if (window.disableViewerContentFetch) { return; }
  if (ConfigurationFactory.isWebPlayer()) { return; }

  if (ConfigurationFactory.isEmbed()) { return; }
  if (ConfigurationFactory.isPreview()) { return; }

  const id = ConfigurationFactory.getId();

  if (ConfigurationFactory.isSharedschedule()) {
    legacyUrl = `https://www.googleapis.com/storage/v1/b/risevision-schedule-notifications/o/${id}%2fsharedschedule.json?alt=media`;
  } else {
    legacyUrl = `https://www.googleapis.com/storage/v1/b/risevision-display-notifications/o/${id}%2fcontent.json?alt=media`;
  }

  GCSControllerCDN.init();
};

const getContentFromLegacyGcs = (cb) => {
  if (!jQuery || !jQuery.getJSON || !legacyUrl) { return cb(); }

  let url = legacyUrl;
  const generation = getCachedGeneration();
  if (generation) {
    url += `&ifGenerationNotMatch=${generation}`;
  }

  Logger.logDebug("Retrieving legacy GCS Data " + url);

  return jQuery.getJSON(url, (result, textStatus, jqXHR) => {
    if (textStatus === "notmodified") {
      return cb(getCachedResult());
    }

    const generation = jqXHR && jqXHR.getResponseHeader && jqXHR.getResponseHeader("x-goog-generation");
    setCachedResult(result, generation);
    cb(result);
  })
  .fail((jqXHR) => {
    const status = jqXHR && jqXHR.status,
      responseText = jqXHR && jqXHR.responseText;
    let result;

    Logger.logExternalMessage("Legacy GCS fetch fail", `status:${status} reason:${responseText} url: ${url}`);
    Logger.viewerError("E999999999", "Legacy GCS fetch fail", `status:${status} reason:${responseText} url: ${url}`);

    if (status === -1 || status === 0) {
      result = getCachedResult();
    }

    cb(result);
  });
};

service.getContent = (cb) => {
  if (!legacyUrl) { return cb(); }

  if (!GCSControllerCDN.isAvailable()) {
    return getContentFromLegacyGcs(cb);
  }

  return GCSControllerCDN.getContent(cb)
  .catch((error) => {
    if (GCSControllerCDN.isCdnErrorRequiringFallback(error)) {
      Logger.logDebug(`GCS CDN requires fallback; falling back to legacy GCS: ${error && error.message}`);
      return getContentFromLegacyGcs(cb);
    }

    const cachedResult = getCachedResult();
    const diagnostics = {
      reason: error && error.message,
      errorCode: error && error.code,
      status: error && error.status,
      httpDetails: error && error.httpDetails,
      cachedResultAvailable: Boolean(cachedResult)
    };
    const diagnosticDetails = JSON.stringify(diagnostics);

    Logger.logExternalMessage("GCS CDN fetch failure", diagnosticDetails);
    Logger.viewerError("E999999999", "GCS CDN fetch failure", diagnosticDetails);
    if (cachedResult) {
      cb(cachedResult);
    }
  });
};

module.exports = service;
